import { isValidCustomerContact } from './validators/functions/is-valid-customer-contact.function';

export * from './dtos/agreement-contact.dto';
export * from './dtos/tenant-contact.dto';
export * from './dtos/third-party-contact.dto';

export * from './enums/tenant-contact-type.enum';

export * from './validators/schemas/agreement-contact.schema';
export * from './validators/schemas/create-agent-contact.schema';
export * from './validators/schemas/create-location-contact.schema';
export * from './validators/schemas/create-supplier-contact.schema';
export * from './validators/schemas/update-agent-contact.schema';
export * from './validators/schemas/update-location-contact.schema';
export * from './validators/schemas/update-supplier-contact.schema';

export const contactValidators = { isValidCustomerContact };
